"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCsv = void 0;
const extractFields = (data) => {
    const fields = [];
    data.forEach((element) => {
        Object.keys(element).forEach((field) => {
            if (!fields.includes(field)) {
                fields.push(field);
            }
        });
    });
    return fields;
};
const dateFormat = (d) => {
    if (!d) {
        return "N";
    }
    return d.toISOString().replace("T", " ").substring(0, 16);
};
const formatValue = (f) => {
    if (f === null) {
        return `""`;
    }
    if (typeof f === "string") {
        return `"${f}"`;
    }
    if (f && typeof f.getMonth === "function") {
        return dateFormat(f);
    }
    if (f === false) {
        return `"false"`;
    }
    if (!f) {
        return `""`;
    }
    return f;
};
const toCsv = (flattenData) => {
    const fields = extractFields(flattenData);
    let output = `${fields.join(",")}\n`;
    flattenData.forEach((element) => {
        output += `${fields.map((field) => formatValue(element[field])).join(",")}\n`;
    });
    return output;
};
exports.toCsv = toCsv;
//# sourceMappingURL=transformToCsv.js.map